import type { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import { TSignPartnerAgreementsRequest } from "./signPartnerAgreements.schema";

export const signPartnerAgreements =
  (axios: IAxiosInstance) => async (body: TSignPartnerAgreementsRequest) => {
    const response = await axios.noRetry.post<IApiResponse<boolean>>(
      `/partners/authorization_documents?accessToken=${body.accessToken}`,
      {
        document_key: body.document_key,
        signature: body.signature,
        partnerID: body.partnerID,
      }
    );

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }
    throw new Error("Something went wrong");
  };
